export default __webpack_public_path__ + "static/cpupic-7c549349573cf49bdbaac52a142f8487.png";